<div class="page-container">
  <app-back-link link="/settings" label="Back to Settings"></app-back-link>
  <app-page-header
    title="MCP Tools Reference"
    description="All available MCP tools, parameters, return shapes, and usage patterns for use in an external LLM system prompt.">
  </app-page-header>

  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>

  <div class="error-panel" *ngIf="error">{{ error }}</div>

  <div class="guide-content" *ngIf="content" [innerHTML]="content | markdown"></div>
</div>
